let view = null;

export default {
	namespace: 'template-service-overview',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ServiceOverviewView } = await import(
			/* webpackChunkName: "service-overview-view" */ '../../templates/ServiceOverviewView'
		);
		view = new ServiceOverviewView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
